import React from "react"
import { Controller } from "react-hook-form"
import { ErrorMessage } from "@hookform/error-message"
import styled from "styled-components"
import { useQuery } from "@apollo/client"
import { CapabilityProvider, InputUpdateStoreMarket } from "lib/types/generated/graphql-types"
import { Common } from "lib/types"
import { Control, UseFormSetValue } from "react-hook-form/dist/types/form"
import { FieldErrors } from "react-hook-form/dist/types/errors"
import SingleSelect from "../../Ui/Form/SingleSelect"
import { ALL_EXTERNAL_PRICE_PROVIDERS } from "../../../graphql/queries/config/AllExternalPriceProviders"

const InputSection = styled.div`
  flex: 1;
  margin-bottom: 2rem;
`

const Label = styled.label`
  font-weight: 700;
  display: flex;
  align-items: center;
  padding-bottom: 0.3rem;
`

type Props = {
  defaultValue: string | undefined
  control: Control
  errors: FieldErrors
  setValue: UseFormSetValue<InputUpdateStoreMarket>
}

export const ExternalPriceSelect = ({ defaultValue, control, errors, setValue }: Props) => {
  const { data: externalPriceData } = useQuery(ALL_EXTERNAL_PRICE_PROVIDERS)
  const externalPriceConfigOptions =
    externalPriceData?.getExternalPriceConfigs.length > 0
      ? externalPriceData?.getExternalPriceConfigs?.map((config: CapabilityProvider) => ({
        label: config.id,
        value: config.id
      }))
      : []
  const options = [{ label: "Select external price config...", value: undefined }, ...externalPriceConfigOptions]
  const updateExternalPriceConfig = (externalPriceConfig: Common.Option) => {
    setValue("cartCapabilities.externalPrice", { id: externalPriceConfig?.value })
  }

  if (externalPriceConfigOptions.length === 0) return null

  return (
    <InputSection>
      <Label>External Price</Label>
      <Controller
        name="cartCapabilities.externalPrice"
        render={() => (
          <SingleSelect
            defaultValue={defaultValue ? { label: defaultValue, value: defaultValue } : options[0]}
            options={options}
            setValue={updateExternalPriceConfig}
          />
        )}
        control={control}
      />
      <ErrorMessage errors={errors} name="cartCapabilities.externalPrice" />
    </InputSection>
  )
}

export default ExternalPriceSelect
